import { GET_UHI_TELE_CONTEXT } from './constants';

type Response = {
    tele: {
        usr: {
            AppointmentID: string;
            ChannelName: string;
            DoctorName: string;
            DoctorURL: string;
            Odid: string;
            Opid: string;
            PToken: string;
            PUserid: string;
            PatientName: string;
            RToken: string;
        };
    };
};
export default (hash: string): Promise<Response> =>
    fetch(GET_UHI_TELE_CONTEXT(hash)).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('failed');
        }
    });
